//import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { getSebKeys } from './utils/seb'

// SEB-Schlüssel so früh wie möglich ermitteln: SEB berechnet sie beim initialen Laden
// der Seite aus der dann aktuellen URL. Bei späterer SPA-Navigation aktualisiert SEB die
// Variablen nicht, deshalb müssen wir sie hier vor jeder React-Router-Navigation cachen.
if (document.readyState === 'loading') {
  window.addEventListener('load', () => getSebKeys());
} else {
  getSebKeys();
}

createRoot(document.getElementById('root')!).render(
  // <StrictMode>
    <App />
  // </StrictMode>,
)
